import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import SelectDropdown from 'flarum/common/components/SelectDropdown';
import classList from 'flarum/common/utils/classList';
import extractText from 'flarum/common/utils/extractText';
import generateLanguageOptions from '../utils/generateLanguageOptions';
import { defaultLanguage } from '../utils/languageFilter';
export default class LanguageDropdown extends SelectDropdown {
  static initAttrs(attrs) {
    attrs.className = classList(attrs.className, 'Dropdown--language');
    attrs.buttonClassName ||= 'Button';
    // As the sort dropdown beside it on the discussion list.
    attrs.caretIcon ??= 'fas fa-caret-down';
    attrs.accessibleToggleLabel ||= extractText(app.translator.trans('fof-discussion-language.forum.language_dropdown.toggle_label'));
    super.initAttrs(attrs);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.selected = this.attrs.selected || defaultLanguage();
  }
  view(vnode) {
    const options = generateLanguageOptions();
    return super.view({
      ...vnode,
      children: Object.keys(options).map(code => {
        const active = this.selected === code;
        return m(Button, {
          active: active,
          icon: active ? 'fas fa-check' : true
          // Its content is a component, which the button can't read a name from.
          ,
          "aria-label": app.store.getBy('discussion-languages', 'code', code)?.name(),
          "data-language": code,
          onclick: () => this.select(code)
        }, options[code]);
      })
    });
  }
  select(code) {
    this.selected = code;
    this.attrs.onselect?.(code);
  }
}
flarum.reg.add('fof-discussion-language', 'forum/components/LanguageDropdown', LanguageDropdown);